import { render, staticRenderFns } from "./StudentSelections.vue?vue&type=template&id=f0c5bf4c&scoped=true&"
import script from "./StudentSelections.vue?vue&type=script&lang=js&"
export * from "./StudentSelections.vue?vue&type=script&lang=js&"
import style0 from "./StudentSelections.vue?vue&type=style&index=0&id=f0c5bf4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c5bf4c",
  null
  
)

export default component.exports